<template>
  <div class="jc-ip-container">
    <div class="jc-page-top">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('ip.publicNetIp')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.IP_SERVER_URL" target="_blank">{{$t('ip.helpDoc',[$t('ip.publicNetIp')])}}</a>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="el-container-table">
          <!-- tableToolBar -->
          <div class="el-container-table-actionBar">
            <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
              <el-form-item>
                <el-input :placeholder="$t('placeholder.ipAddressSegment')" v-model="search" @keyup.enter.native="handleSearch" class="my-input"  clearable @clear="handleSearch">
                  <el-button slot="append" @click="handleSearch" icon="el-icon-search" class="search-icon"></el-button>
                </el-input>
              </el-form-item>
              <!-- tag -->
                <el-form-item>
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
              <el-form-item class="set-icon">
                <el-button icon="el-icon-setting" class="jc-button-icon" @click="setCustom()" :title="$t('merge.customList')"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="jc-icon-download" class="jc-button-icon" @click="exportList" :title="$t('speechcraft.exportResourceList')"></el-button>
              </el-form-item>
            </el-form>
            <el-form class="el-table-actionBar-item" :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line" class="el-button-icon" @click="updateList" v-if="fliter_region.length"></el-button>
              </el-form-item>
              <el-form-item>
                <!-- <el-radio-group v-model="selectedRegion" @change="selectRegion">
                    <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                      <el-radio-button v-for="room in fliter_region"
                                    :key="room.idcId"
                                    :label="room.idcId"
                        >{{ room.region }}</el-radio-button
                      >
                    </el-radio-group-advance>
                  </el-radio-group> -->
                  <el-select v-model="selectedRegion" @change="selectRegion" :placeholder="$t('placeholder.choose')">
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.idcId"
                      :value="room.idcId"
                      :label="room.region">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="el-container-table">
            <el-table :data="ipAddressList" style="width: 100%" v-loading="refreshloading" :empty-text="tableEmptyTip" @filter-change="changeFilter" @selection-change="handleSelectionChange">
              <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column prop="ipId"
                                 key="ipId"
                                 min-width="180"
                                 :label="$t('text.id')"
                                 v-if="customerInfo !== null && customerInfo['ipId'].selected">
                  <template slot-scope="scope">
                    <span v-if=" scope.row.cidrAddr !== ''">{{scope.row.ipId}}</span>
                      <span v-else>--</span>
                  </template>
                </el-table-column>
              <el-table-column key="cidrAddr" min-width="160" prop="cidrAddr" :label="$t('ip.ipAddressSegment')" v-if="customerInfo !== null && customerInfo['cidrAddr'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.cidrAddr !== ''">{{scope.row.cidrAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="ipQuantity" min-width="100" prop="ipQuantity" :label="$t('ip.ipAmount')" v-if="customerInfo !== null && customerInfo['ipQuantity'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.ipQuantity !== ''">{{scope.row.ipQuantity}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="ipType" prop="ipType" min-width="100" :label="$t('ip.ipType')" v-if="customerInfo !== null && customerInfo['ipType'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.ipType !== ''">{{scope.row.ipType}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="networkAddr" prop="networkAddr" min-width="120" :label="$t('ip.netWorkAddr')" v-if="customerInfo !== null && customerInfo['networkAddr'].selected" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if=" scope.row.networkAddr !== ''">{{scope.row.networkAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="gatewayAddr" prop="gatewayAddr" :label="$t('ip.gatewayAddress')" v-if="customerInfo !== null && customerInfo['gatewayAddr'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.gatewayAddr !== ''">{{scope.row.gatewayAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="broadcastAddr" prop="broadcastAddr" :label="$t('ip.bordcastAddr')" v-if="customerInfo !== null && customerInfo['broadcastAddr'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.broadcastAddr !== ''">{{scope.row.broadcastAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
               <!-- 线路类型 -->
              <el-table-column key="lineTypeName" min-width="100" prop="lineTypeName" :label="$t('bandWidth.lineType')" v-if="customerInfo !== null && customerInfo['lineType'].selected" :filter-multiple="false" :filters="filterList.lineType" :filter-method="filtersIpStatus" :filtered-value="filtersValue.lineType">
                <template slot-scope="scope">
                 <span v-if="scope.row.lineTypeName && scope.row.lineTypeName !== ''">{{scope.row.lineTypeName}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column key="status" prop="status" :label="$t('text.status')" v-if="customerInfo !== null && customerInfo['status'].selected" :filter-multiple="false" :filters="filterList.status" :filter-method="filtersIpStatus" :filtered-value="filtersValue.status">
                <template slot-scope="scope">
                  <span :class="statusMap[scope.row.status]">{{filter_status[scope.row.status]}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="customerInfo !== null && customerInfo['tags'].selected"
                               min-width="150"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
                <!--操作-->
                <!-- <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')">
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button>

                    </div>
                  </template>
                </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar" v-if="ipAddressList.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>
      <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalItems">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
    <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList">
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from '../common/custom/Custom.vue';
import { ServiceCodeConstant } from '@/common/Constants';

const type = 'ip';

export default {
  components: {
    custom
  },
  name: 'ip-address',
  data () {
    return {
      refreshloading: false,
      ipAddressList: [],
      statusMap: {
        'abnormal': 'jc-status jc-status--orange',
        'normal': 'jc-status jc-status--green'
      },
      filter_status: {
        'normal': this.$t('text.normal'),
        'abnormal': this.$t('text.abnormal'),
      },
      filtersValue: {
        lineType: [],
        status: [],
      },
      search: '',
      currentPage: 1,
      totalItems: 0,
      pageSize: 20,
      pageSizes: [20, 50, 100],
      selectedRegion: null,
      fliter_region: [],
      regionMap: [],
      customVisible: false,
      type,
      initFlag: false,
      tableEmptyTip: this.$t('text.noSearch'),

      optionArr: [
        {
          label: this.$t('text.id'),
          value: 'ipId'
        },
        { label: this.$t('ip.ipAddressSegment'), value: 'cidrAddr' },
        { label: this.$t('ip.ipAmount'), value: 'ipQuantity' },
        { label: this.$t('ip.ipType'), value: 'ipType' },

        { label: this.$t('ip.netWorkAddr'), value: 'networkAddr' },
        { label: this.$t('ip.gatewayAddress'), value: 'gatewayAddr' },
        { label: this.$t('ip.bordcastAddr'), value: 'broadcastAddr' },
        { label: this.$t('bandWidth.lineType'), value: 'lineType' },
        { label: this.$t('text.status'), value: 'status' },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        }
        // {
        //   // 操作
        //   label: this.$t('text.operate'),
        //   value: 'operation'
        // }
      ],
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],
    };
  },
  created () {
    const query = this.$route.query;
    if (query.selectRoom !== undefined) {
      this.selectedRegion = query.selectRoom;
    }
    if (query.status !== undefined) {
      this.filtersValue.status.push(query.status);
    }

    // 获取区域信息
    this.getRegion();

    // 自定义表头
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  mounted () { },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    needRequireResource () {
      return !!this.selectedRegion;
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
    customerInfo () {
      return this.$store.state.customInfo[this.type];
    },
    filter_lineTypeName () { // 线路类型下拉选
      const tempArray = [];
      if (this.filterList.ipLineType) {
        this.filterList.ipLineType.forEach((element) => {
          tempArray.push({
            text: element.text,
            value: element.value
          });
        });
      }
      return tempArray;
    },
  },
  methods: {
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.ipId);
      });
      this.editTagDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.ipId]);
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    filterLineTypeName () {
      return true;
    },
    getRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.regionFormat(data);
            if (this.$route.query.selectRoom !== undefined) {
              this.$nextTick(() => {
                this.selectedRegion = this.$route.query.selectRoom;
              })
            } else if (res.data.idcs) {
              this.$nextTick(() => {
                this.selectedRegion = res.data.idcs[0].idc;
              })
            }
            this.$nextTick(() => {
              this.selectedRegion.length && this.selectRegion();
            })
          } else {
            this.fliter_region = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },

    // 获取自定义信息
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
        }
      });
    },

    // 获取列表
    getIpAddress (params) {
      if (!this.needRequireResource) {
        return;
      }
      const dataParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idc: this.selectedRegion
      };
      const tempParams = params === undefined ? dataParams : params;
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        tempParams.ipId = this.filteredResourceIds.join(',');
      }
      this.refreshloading = true;
      this.$api.getNetworksList(tempParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.ips.length > 0 && res.data.ips[0] != null) {
            const data = res.data.ips;
            this.totalItems = res.data.totalCount;
            this.refreshloading = false;
            this.ipAddressList = cloneDeep(data);
            this.ipAddressList.forEach((item) => {
              item.tagPairs = '';
              if (item.tags !== undefined && item.tags.length > 0) {
                item.tags.forEach((tag) => {
                  item.tagPairs += `${tag.key}:${tag.value},`;
                });
                item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
              }
            });
          } else {
            this.refreshloading = false;
            this.ipAddressList = [];
            this.totalItems = 0;
          }
        } else {
          this.refreshloading = false;
          this.$message.error(res.errmsg);
        }
        this.initFlag = false;
      }, (error) => {
        this.refreshloading = false;
        this.ipAddressList = [];
        this.totalItems = 0;
        this.$message.error(error.message);
      }).finally(() => {
        this.refreshloading = false;
        this.filteredResourceIds = [];
      });
    },

    regionFormat (data) {
      this.fliter_region = [];
      for (let i = 0; i < data.length; i++) {
        this.fliter_region.push({
          idcId: data[i].idc,
          idcNo: data[i].idcNo,
          region: data[i].idcName
        });
      }
    },

    updateList (type) {
      if (!this.needRequireResource) {
        return;
      }
      // 切换区域不保留条件
      this.tableEmptyTip = this.$t('text.noSearch');
      if (type == 'refresh') {
        this.refreshloading = true;
        this.search = '';
        this.initFlag = true;
        this.currentPage = 1;
        this.tableEmptyTip = this.$t('text.noSearch');
      }
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idc: this.selectedRegion
      };
      if (this.search.trim() != '') {
        this.tableEmptyTip = this.$t('text.hasSearch');
        params = Object.assign(params, { cidrAddr: this.search });
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          params[key] = this.filtersValue[key][0];
        }
      });
      this.getIpAddress(params);
    },

    // 搜索
    handleSearch () {
      this.initFlag = true;
      this.currentPage = 1;
      this.updateList();
    },

    // 导出列表
    exportList () {
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportIps?idc=${this.selectedRegion}&cidrAddr=${this.search}&all=1`;
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          url += `&${key}=${this.filtersValue[key][0]}`;
        }
      });
      window.open(url, '_self');
    },

    // 自定义
    setCustom () {
      this.customVisible = true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.updateList();
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      if (!this.initFlag) {
        this.updateList();
      }
    },

    filterIpAddressType (value, row) {
      return row.status === value;
    },

    selectRegion () {
      if (this.fliter_region.length > 0) {
        this.updateList('refresh');
      }
    },

    transformParams () {
      let param = this.$route.query.ipStatus;
      if (param === 'normal') {
        param = 1;
      } else if (param === 'abnormal') {
        param = 2;
      } else {
        param = '';
      }
      return param;
    },

    filtersIpStatus (value, row) {
      return true;
    },

    // 根据状态搜索
    changeFilter (filter) {
      this.currentPage = 1;
      this.updateList('refresh');
    }
  }
};
</script>
<style lang="sass">
  @import "./IpAddress.scss"
</style>



// WEBPACK FOOTER //
// src/components/ipAddress/IpAddress.vue